// import $ from 'jquery';
import eventProxy from './eventProxy';

export default class DragSelection {
  constructor(fileBody, layout, list) {
    this.fileBody = fileBody;
    this.layout = layout;
    this.list = list;
    this.selectedList = [];

    // 私有属性
    this._beforeScrollTop = 0;
    this._shiftStartId = '';
    this._selectedMap = {};

    this._getIncludeIndex = this._getIncludeIndex.bind(this);
    this.selectorStart = this.selectorStart.bind(this);
    this.selectorMove = this.selectorMove.bind(this);
    this.selectorEnd = this.selectorEnd.bind(this);
  }

  refresh(el, layout, list) {
    this.fileBody = el;
    this.layout = layout;
    this.list = list;
  }

  // 私有函数
  _getColCount() {
    const list = this.fileBody.find('.finder-item');
    if (list.length <= 1) return 1;
    const len = list.length;
    const left0 = list[0].offsetLeft;
    let i = 1;
    for (; i < len; i++) {
      if (list[i].offsetLeft === left0) return i;
    }
    return i;
  }

  // 私有函数
  _getIncludeIndex(data) {
    const touch = {};
    const isGrid = this.layout === 'grid';
    const rectLeftTop = this.fileBody.offset();
    const rectRightBottom = {
      left: rectLeftTop.left + this.fileBody.width(),
      top: rectLeftTop.top + this.fileBody.height(),
    };

    if (isGrid) {
      rectRightBottom.left += 20;
      rectRightBottom.top += 20;
    }
    // TODO: 拖拽选区下滑
    // const currentScrollTop = this.fileBody.scrollTop();
    // const offsetScroll = currentScrollTop - this._beforeScrollTop;
    // if (offsetScroll >= 0) {
    //   data.y2 += offsetScroll;
    // } else {
    //   data.y1 += offsetScroll;
    // }

    const marginX = isGrid ? 8 : 0;
    const marginY = isGrid ? 8 : 0;

    const startPosition = isGrid ? { x: 4, y: 4 } : { x: 0, y: 0 };
    const lineCount = this._getColCount();
    const $items = this.fileBody.find('.finder-item');
    const len = $items.length;
    const maxI = lineCount - 1;
    const maxJ = len - 1;
    const item0 = $items.eq(0);
    const itemW = (maxI >= 1 && ($items.eq(maxI).offset().left - item0.offset().left) / (maxI % lineCount) - marginX)
        || item0.width();
    const itemH = (maxJ >= 1 && ($items.eq(maxJ).offset().top - item0.offset().top) / Math.floor(maxJ / lineCount)
        - marginY) || item0.height();

    this.list.forEach((item, index) => {
      const x1 = startPosition.x + (index % lineCount) * (itemW + marginX) + rectLeftTop.left;
      const y1 = startPosition.y + Math.floor(index / lineCount) * (itemH + marginY) + rectLeftTop.top
          - this._beforeScrollTop;
      const x2 = x1 + itemW;
      const y2 = y1 + itemH;

      // 判断选区是否在视窗中
      if (
        data.x1 <= rectRightBottom.left
        && data.y1 <= rectRightBottom.top
        && data.x2 >= rectLeftTop.left
        && data.y2 >= rectLeftTop.top
      ) {
        // 判断文件是否在选择器中
        if (x1 <= data.x2 && y1 <= data.y2 && x2 > data.x1 && y2 > data.y1) {
          // 判断文件是否在视窗中
          if (y1 <= rectRightBottom.top && y2 >= rectLeftTop.top) {
            touch[index] = true;
          }
        }
      }
    });

    return touch;
  }

  // 拖选文件开始
  selectorStart(data) {
    this._beforeScrollTop = this.fileBody.scrollTop();

    this.selectedList = [];
    const touch = this._getIncludeIndex(data);
    const keys = Object.keys(touch);
    const { event } = window;
    const _selectedMap = {};
    this.list.forEach(item => {
      _selectedMap[item.key] = item.checked || false;
    });
    this._selectedMap = _selectedMap;
    if (keys.length === 0) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        this.list = this.list.map((item, index) => {
          item.checked = item.checked || touch[index];
          return item;
        });
      } else {
        this.list = this.list.map((item, index) => {
          item.checked = !!touch[index];
          return item;
        });
      }
    } else if (this.list[keys[0]].checked === true) {
      eventProxy.emit('command.stop-select');
    } else if (!this.list[keys[0]].checked && event.shiftKey) {
      let shiftStart;
      let shiftEnd = 0;
      if (this._shiftStartId !== '') {
        let index = 0;
        let item = this.list[index];
        while (item && item.key !== this._shiftStartId) {
          item = this.list[++index];
        }
        shiftStart = index;
      }
      shiftStart === undefined && (shiftStart = 0);
      shiftEnd = Math.max(shiftStart, keys[0]);
      shiftStart = Math.min(shiftStart, keys[0]);
      this.list = this.list.map((item, index) => {
        if (index >= shiftStart && index <= shiftEnd) {
          item.checked = true;
        }
        return item;
      });
    }

    this.selectedList = this.list.filter(item => item.checked);
  }

  // 拖选区域移动
  selectorMove(data, type) {
    const { event } = window;
    const touch = this._getIncludeIndex(data);
    if (event && (event.ctrlKey || event.metaKey)) {
      this.list = this.list.map((item, index) => {
        item.checked = touch[index] ? !this._selectedMap[item.key] : !!this._selectedMap[item.key];
        return item;
      });
    } else if (event && event.shiftKey) {
      if (type !== 'end') {
        this.list = this.list.map((item, index) => {
          item.checked = this._selectedMap[item.key] || touch[index];
          return item;
        });
      }
    } else {
      this.list = this.list.map((item, index) => {
        item.checked = !!touch[index];
        return item;
      });
    }

    if (type === 'end') {
      const keys = Object.keys(touch);
      if (keys.length && this.list[keys[0]]) {
        this._shiftStartId = this.list[keys[0]].key;
      }
    }

    this.selectedList = this.list.filter(item => item.checked);
  }

  // 拖选区域结束移动
  selectorEnd(data) {
    this.selectorMove(data, 'end');
  }
}
